import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
// import { AdminRoutingModule } from '../../core/routing/admin-routing.module';
import { GeneratePasswordFormModule, LoginPermissionsModule, NewUserFormModule } from '@component';
import { AdminComponent } from 'src/app/view/admin/admin.component';

@NgModule({
  declarations: [AdminComponent],
  exports: [AdminComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatIconModule,
    RouterModule,
    MatButtonModule,
    ReactiveFormsModule,
    GeneratePasswordFormModule,
    NewUserFormModule,
    LoginPermissionsModule,
    MatExpansionPanel,
    MatAccordion,
    MatExpansionPanelTitle,
    MatExpansionPanelHeader,
    // AdminRoutingModule,
  ],
})
export class AdminModule {}
